export class FacturePersonnalisation {
    afp_id: string = null;
    afp_role_id: string = null;
    afp_color: string = "#fff";
    afp_logo_align: string = "left";
    afp_condition_paiement = "";
    afp_condition_paiement_en = "";
    afp_condition_paiement_de = "";
    afp_condition_paiement_nl = "";
    afp_footer = "";
    afp_footer_align: string = "center";
    afp_large_header: number = 0;


    constructor(init?: Partial<FacturePersonnalisation>) {
        Object.assign(this, init);
    }

}